<div class="loading-more">
  <nz-spin nzSimple *ngIf="loadingMore"></nz-spin>
  <div class="no-more-data" *ngIf="isLastPage">
    <span>All Data Here</span>
  </div>
</div>
